/**
 * Skylite Desktop OS Interface
 * Copyright © 2024 Enterceptor Corp
 * All Rights Reserved
 * 
 * This file and its contents are protected by copyright law.
 * Unauthorized reproduction or distribution is prohibited.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App.js';
import { LanguageProvider } from './contexts/LanguageContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <LanguageProvider>
    <App />
    </LanguageProvider>
  </React.StrictMode>
); 